"use strict";

var _require = require('ramda'),
    join = _require.join,
    map = _require.map;

var processors = require('./processors');

var E_MISSING_PROCESSOR = new Error('Specified processor not found');
var E_UNKNOWN_ENTITY = new SyntaxError('Unknown entity');

function processVariable(processor, data, value, loose) {
  if (loose) {
    return null;
  }

  if (processor == null) {
    throw E_MISSING_PROCESSOR;
  }

  return processor(value, data);
}

function stringifyVariable(_ref, data, value, loose) {
  var name = _ref.name,
      processor = _ref.processor;

  if (!loose && value == null) {
    return "{{".concat(name, "}}");
  }

  if (processor) {
    return processVariable(processors[processor.name], data, value, loose);
  }

  return value;
}

module.exports = function stringify(input, data, variables, loose) {
  if (input.length === 1 && typeof input[0] === 'string') {
    return input[0];
  } // transform everything to strings


  return join('', map(function (x) {
    // return string as is
    if (typeof x === 'string') {
      return x;
    } // if `type` is `variable`, stringify it using given data


    if (x && x.type && x.type === 'variable') {
      return stringifyVariable(x, data || {}, (variables || {})[x.name], loose);
    } // otherwise throw


    throw E_UNKNOWN_ENTITY;
  }, input));
};